import UserHelpers from 'common/dist/virtuals/User';

export default function getListOwnerFullName(list) {
    const primaryUser = list.users.find(user => user.isPrimary);
    return UserHelpers.fullName(primaryUser.client);
  }
